import { useOidc } from "@bnsf/oidc-token-lib-react/lib";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useMemo, useState } from "react";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { userStore } from "../stores/user";
import HandleAuth from "./HandleAuth";
import { AdminPage } from "./admin/adminPage";
import { PatternMaintenance } from "./admin/patternMaintenance";
import { ReasonCodeAdmin } from "./admin/reasonCodeAdmin";
import { UserAdmin } from "./admin/userAdmin";
import { ComparePage } from "./comparePage";
import { HistoryPage } from "./historyPage";
import { NavigationHeader } from "./navigationHeader";
import { OutageList } from "./outageList";
import RequestHistory from "./requestHistory";
import { SlsItemList } from "./sls/slsItemList";
import { SubdivisionRecalculate } from "./subdivisionRecalculate";
import { TabsView } from "./tabs";
import { ServerActions } from "../actions/serverActions";

const { ROUTE_AUTH_MESSAGES, ActionTypes } = Constants;

const UnAuthPage = ({ path }) => {
  useEffect(() => {
    if (path) {
      const authMsg = ROUTE_AUTH_MESSAGES[path] || path;
      dispatcher.dispatch({
        type: ActionTypes.AUTHENTICATION_FAILED,
        message: [
          {
            message: `You do not have access to the ${authMsg} Page`,
            type: "error",
          },
        ],
      });
    }
  }, [path]);
  return <Navigate to="/" />;
};

const PrivateAuth = ({ path, children }) => {
  const userRoles = userStore.getUserRole();
  const isAuthenticated = useMemo(() => {
      if (Array.isArray(userRoles)) {
          if (userRoles.includes(Constants.Roles.SUPER_USER) ||
              userRoles.includes(Constants.Roles.ADMIN)) {
              return true;
          }
      }
    return false;
  }, [userRoles]);

  return isAuthenticated ? <>{children}</> : <UnAuthPage path={path} />
};

const RootComponent = () => {
  return (
    <NavigationHeader>
      <Outlet />
    </NavigationHeader>
  );
};

const AuthFlowHandle = () => {
  const navigate = useNavigate();

  const checkRedirect = () => {
    const urlRef = sessionStorage.getItem("app:redirect"); //Check if there is a saved redirect
    if (urlRef != null) {
      //If it exists then redirect to that page
      console.log("the request URL app:redirect: " + urlRef);
      sessionStorage.removeItem("app:redirect"); // Remove so there will be no redirect next time
      navigate(urlRef);
    } else {
      navigate("/");
    }
  }

  useEffect(() => {
    checkRedirect();
  }, []);

  return (<div className="loader" />);
};

const Router = () => {
  const { authUser } = useOidc();

  const [isLoading, setLoading] = useState(true);

    const [rolesFetched, setRolesFetched] = useState(false);

  const decordValue = (value) => {
    try {
      return decodeURIComponent(escape(value));
    }
    catch (ex) {
      return value;
    }
  };


    useEffect(() => {
    if (authUser && !window.gritConfig) {
      //Load config values from server
      $.ajax({
        url: "/setConfigObject",
        type: "GET",
        async: false,
        headers: {
          Authorization: `Bearer ${authUser.access_token}`,
          Accept: "application/json",
        },
      })
        .done((data) => {
          window.gritConfig = {
            ...data,
            authUser,
            gritEnvironment: data.gritEnv,
            weatherWarningKey: decordValue(data.weatherWarningKey)
          };
          ServerActions.getUserRole().done(response=>{
            if(response){
              setRolesFetched(true);
            }
          });
        })
        .fail((status) => {
          console.error("Unable to load OIDC config from server", status);
        }).always(() => setLoading(false));
    } else if (authUser && window.gritConfig) {
      window.gritConfig.authUser = authUser;
      setLoading(false);
    }
  }, [authUser, window.gritConfig]);

  if (!authUser || isLoading || !rolesFetched) {
    return <HandleAuth />;
  }

  return (
    <Routes>
      <Route path="/" element={<RootComponent />}>
        <Route
          path="requestHistoryList"
          element={<RequestHistory />}
        />
        <Route
          key={6}
          path="patternsMaintenance"
          element={<PatternMaintenance />}
        />
        <Route
          key={7}
          path="historyPage"
          element={<HistoryPage />}
        />
        <Route
          key={1}
          path="override"
          element={<PrivateAuth><AdminPage /></PrivateAuth>}
        />
        <Route
          key={2}
          path="compare"
          element={<PrivateAuth><ComparePage /></PrivateAuth>}
        />
        <Route
          key={3}
          path="defaultTracks"
          element={<PrivateAuth><AdminPage /></PrivateAuth>}
        />
        <Route
          key={4}
          path="reasonCodes"
          element={<PrivateAuth><ReasonCodeAdmin /></PrivateAuth>}
        />
        <Route
          key={5}
          path="gritUser"
          element={<PrivateAuth><UserAdmin /></PrivateAuth>}
        />
        <Route
          key={5.6}
          path="outageList"
          element={<PrivateAuth><OutageList /></PrivateAuth>}
        />
        <Route
          key={8}
          path="gritItems"
          element={<SlsItemList />}
        />
        <Route
          key={9}
          path="subRecalculate"
          element={<PrivateAuth><SubdivisionRecalculate /></PrivateAuth>}
        />
        <Route key={1.2} path="authgrantflowredirect" element={<AuthFlowHandle />} />
        <Route key={10} path="restriction" element={<TabsView />} />
        <Route key={11} path="request" element={<TabsView />} />
        <Route key={12} path="signout" element={<TabsView />} />
        <Route key={0} index element={<TabsView />} />
      </Route>
    </Routes>
  );
};

export default Router;
